export const SHOW_BRAND_BROCHURE_DOWNLOAD = false;
